import { makeApiCall } from "../makeApiCall";

const superAdminService = {
  // Pricing Management
  createPricing: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/pricing/create`,
      data,
    }),
  getPricingList: (params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/pricing/list`,
      params,
    }),
  getPricingById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/pricing/${id}`,
    }),
  updatePricing: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/pricing/update`,
      data,
    }),
  activatePricing: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/pricing/activate/${id}`,
    }),
  deactivatePricing: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/pricing/deactivate/${id}`,
    }),
  getPricingDropdown: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/pricing/dropdown/list`,
    }),
  getPricingLinkedCustomers: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/pricing/linkedCustomers/${id}`,
    }),
  checkActivePricing: (params: {
    appId: number;
    countryId?: number | null;
    stateId?: number | null;
    pricingType?: string | null;
  }): Promise<any> => {
    const queryParts = [`appId=${params.appId}`];
    if (params.countryId) queryParts.push(`countryId=${params.countryId}`);
    if (params.stateId) queryParts.push(`stateId=${params.stateId}`);
    if (params.pricingType) queryParts.push(`pricingType=${params.pricingType}`);
    return makeApiCall<any>({
      method: "get",
      url: `/super-admin/pricing/check-active?${queryParts.join("&")}`,
    });
  },

  // Module Dropdown
  getModuleDropdown: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/module-access/dropdown`,
    }),

  // Application Management
  createApplication: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/application/create`,
      data,
    }),
  updateApplication: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/application/update`,
      data,
    }),
  getApplicationList: (params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/application/list`,
      params,
    }),
  getAppDropdown: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/application/dropdown`,
    }),
  getApplicationById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/application/${id}`,
    }),
  getApplicationModules: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/application/${id}/modules`,
    }),
  mapModulesToApp: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/application/map-modules`,
      data,
    }),
  unmapModuleFromApp: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/application/unmap-module`,
      data,
    }),
  bulkUnmapModulesFromApp: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/application/bulk-unmap-modules`,
      data,
    }),

  // Bundle Management
  createBundle: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/bundle/create`,
      data,
    }),
  getBundleList: (params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/bundle/list`,
      params,
    }),
  getBundleById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/bundle/${id}`,
    }),
  updateBundle: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/bundle/update`,
      data,
    }),
  activateBundle: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/bundle/activate/${id}`,
    }),
  deactivateBundle: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/bundle/deactivate/${id}`,
    }),
  getBundleDropdown: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/bundle/dropdown/list`,
    }),
  getBundleLinkedCustomers: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/bundle/linkedCustomers/${id}`,
    }),
  getCustomerBundles: (customerId: number): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/bundle/customer/${customerId}`,
    }),
  assignBundleToCustomer: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/bundle/assignCustomer`,
      data,
    }),
  unassignBundleFromCustomer: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/bundle/unassignCustomer`,
      data,
    }),
  updateCustomerBundle: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/bundle/updateCustomerBundle`,
      data,
    }),
  checkActiveBundle: (params: {
    countryId?: number | null;
    stateId?: number | null;
    pricingType?: string | null;
    appIds?: number[];
  }): Promise<any> => {
    const queryParts: string[] = [];
    if (params.countryId) queryParts.push(`countryId=${params.countryId}`);
    if (params.stateId) queryParts.push(`stateId=${params.stateId}`);
    if (params.pricingType) queryParts.push(`pricingType=${params.pricingType}`);
    if (params.appIds?.length) queryParts.push(`appIds=${params.appIds.join(",")}`);
    return makeApiCall<any>({
      method: "get",
      url: `/super-admin/bundle/check-active${queryParts.length ? `?${queryParts.join("&")}` : ""}`,
    });
  },

  // Coupon Management
  createCoupon: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/coupon/create`,
      data,
    }),
  getCouponList: (params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/coupon/list`,
      params,
    }),
  getCouponById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/coupon/${id}`,
    }),
  updateCoupon: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/coupon/update`,
      data,
    }),
  activateCoupon: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/coupon/activate/${id}`,
    }),
  deactivateCoupon: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/coupon/deactivate/${id}`,
    }),
  getCouponDropdown: (customerId?: number): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/coupon/dropdown/list${customerId ? `?customerId=${customerId}` : ''}`,
    }),
  getCouponLinkedCustomers: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/coupon/linkedCustomers/${id}`,
    }),
  linkCouponToCustomer: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/coupon/link`,
      data,
    }),
  unlinkCouponFromCustomer: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/coupon/unlink`,
      data,
    }),
  getCustomerCouponHistory: (customerId: number): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/coupon/customer/${customerId}/all`,
    }),

  // Invoice Management
  getInvoiceList: (params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/invoice/list`,
      params,
    }),
  getInvoiceById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/invoice/${id}`,
    }),
  createManualInvoice: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/invoice/createManual`,
      data,
    }),
  updateInvoice: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/invoice/update`,
      data,
    }),
  sendInvoice: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/invoice/send`,
      data,
    }),
  resendInvoice: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/invoice/resend`,
      data,
    }),
  cancelInvoice: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/invoice/cancel`,
      data,
    }),
  retryInvoice: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/invoice/retry/${id}`,
    }),
  bulkSendInvoices: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/invoice/bulkSend`,
      data,
    }),
  bulkRetryInvoices: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/invoice/bulkRetry`,
      data,
    }),
  adjustFromAdvance: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/invoice/adjustFromAdvance`,
      data,
    }),

  // Receivables Management
  getCustomerReceivableDetail: (customerId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/receivables/customer/${customerId}`,
    }),
  getAdvancePaymentsList: (customerId: any, params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/receivables/advanceList/${customerId}`,
      params,
    }),
  getReceivablesDashboard: (params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/receivables/dashboard`,
      params,
    }),
  recordPayment: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/receivables/recordPayment`,
      data,
    }),
  recordAdvancePayment: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/receivables/recordAdvancePayment`,
      data,
    }),
  updateAdvancePayment: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/receivables/updateAdvancePayment`,
      data,
    }),
  cancelAdvancePayment: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/receivables/cancelAdvancePayment`,
      data,
    }),
  getAgingReport: (params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/receivables/agingReport`,
      params,
    }),
  holdCustomer: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/receivables/hold`,
      data,
    }),
  unholdCustomer: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/receivables/unhold`,
      data,
    }),
  sendPaymentReminder: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/receivables/sendReminder`,
      data,
    }),
  bulkHoldCustomers: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/receivables/bulkHold`,
      data,
    }),
  bulkUnholdCustomers: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/receivables/bulkUnhold`,
      data,
    }),
  getPendingPayments: (params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/receivables/pendingPayments`,
      params,
    }),
  approvePayment: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/receivables/approvePayment`,
      data,
    }),
  rejectPayment: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/receivables/rejectPayment`,
      data,
    }),

  // Customer Management
  getCustomerList: (params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/customer/list`,
      params,
    }),
  getCustomerById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/customer/${id}`,
    }),
  getCustomerDropdown: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/customer/dropdown/list`,
    }),
  getUnlinkedOrgs: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/customer/unlinkedOrgs`,
    }),
  setupPartyForOrg: (orgId: number): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/customer/setupParty`,
      data: { orgId },
    }),
  activateCustomer: (customerId: number): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/customer/activate`,
      data: { customerId },
    }),

  // Billing Config
  getBillingConfig: (customerId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/billing-config/customer/${customerId}`,
    }),
  getBillingConfigHistory: (customerId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/billing-config/customer/${customerId}/history`,
    }),
  updateBillingConfig: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/billing-config/update`,
      data,
    }),

  // Module Access
  getModuleAccess: (customerId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/module-access/customer/${customerId}`,
    }),
  assignModule: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/module-access/assign`,
      data,
    }),
  bulkAssignModules: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/module-access/bulk-assign`,
      data,
    }),
  updateModuleAccess: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/module-access/update`,
      data,
    }),
  revokeModuleAccess: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/module-access/revoke`,
      data,
    }),
  bulkRevokeModuleAccess: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/module-access/bulk-revoke`,
      data,
    }),
  bulkUpdateModuleAccess: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/module-access/bulk-update`,
      data,
    }),
  getModuleAccessLogs: (customerId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/module-access/logs/${customerId}`,
    }),

  // User Limits
  getUserLimits: (customerId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/user-limits/customer/${customerId}`,
    }),
  updateUserLimits: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/user-limits/update`,
      data,
    }),

  // Tax Master
  createTax: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/tax-config/create`,
      data,
    }),
  getTaxList: (params?: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/tax-config/list`,
      params,
    }),
  getTaxById: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/tax-config/${id}`,
    }),
  updateTax: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/tax-config/update`,
      data,
    }),
  deleteTax: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "delete",
      url: `/super-admin/tax-config/${id}`,
    }),
  getTaxDropdown: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/tax-config/dropdown`,
    }),

  // Tax Config (Customer)
  getTaxConfig: (customerId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/tax-config/customer/${customerId}`,
    }),
  updateTaxConfig: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/tax-config/config/update`,
      data,
    }),

  // Access Control
  getAccessControlStatus: (customerId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/access-control/status/${customerId}`,
    }),
  getAccessControlLogs: (customerId: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/access-control/logs/${customerId}`,
    }),
  holdCustomerAccess: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/access-control/hold`,
      data,
    }),
  unholdCustomerAccess: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/access-control/unhold`,
      data,
    }),

  // Scheduler Management
  getSchedulerJobsSummary: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/scheduler/jobs-summary`,
    }),
  getSchedulerJobHistory: (queueName: string, status?: string, limit?: number): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/scheduler/job-history`,
      params: { queueName, status: status || "completed", limit: limit || 20 },
    }),
  retriggerSchedulerJob: (queueName: string): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/super-admin/scheduler/retrigger`,
      data: { queueName },
    }),
  getSchedulerQueueStats: (queueName: string): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/scheduler/queue-stats`,
      params: { queueName },
    }),
  getSchedulerConfig: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/super-admin/scheduler/get-config`,
    }),
  updateSchedulerJobSchedule: (data: { queueName: string; cronExpression: string }): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/super-admin/scheduler/update-schedule`,
      data,
    }),
};

export default superAdminService;
